import { render, staticRenderFns } from "./TextLink.vue?vue&type=template&id=402f1ac5&scoped=true&"
import script from "./TextLink.vue?vue&type=script&lang=ts&"
export * from "./TextLink.vue?vue&type=script&lang=ts&"
import style0 from "./TextLink.vue?vue&type=style&index=0&id=402f1ac5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402f1ac5",
  null
  
)

export default component.exports